import React, { Component } from 'react';
import { Form, Input } from 'antd';
import _ from 'lodash';

import { APIGEE_API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';
import { genFormItemAtrribute } from 'libs/FormHelper';
import styles from './styles.module.scss';
export default class StockAll extends Component {
  state = {
    stockTotal: 0,
  };
  componentDidMount() {
    const productId = this.props.productId || '';
    if (productId) {
      this.getProductStock({ queryAll: true, productKey: productId });
    }
  }
  getProductStock = (params) => {
    whttp.postApigeeApi(
      APIGEE_API_HOST + '/api/v1/oms/cec/website/stock/query',
      params,
      (state, res) => {
        if (state === false) {
          return console.log('發生錯誤');
        }

        if (res.code !== '200') {
          return console.log('ErrorReason', res.reason);
        }
        console.log('res', res);

        this.setState({ stockTotal: res.data.stockTotal });
      }
    );
  };
  render() {
    const stockTotal = this.state.stockTotal;

    return (
      <div className={styles['stock-message']}>
        <p>{`全台限量庫存：尚有 ${stockTotal} 組`}</p>
      </div>
    );
  }
}

// 編輯器
export class StockAllEditor extends Component {
  formRef = React.createRef();

  componentDidMount() {
    this.formRef.current.setFieldsValue(this.props.attributes);
  }
  handleInput = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/[^0-9]/g, '');
    e.target.value = numericValue;
  };
  render() {
    return (
      <div className="vu-blocks-editor">
        <div class="components-placeholder__label">
          <span class="block-editor-block-icon">
            <div class="dashicons dashicons-megaphone" />
          </span>
          全台總庫存量
        </div>
        <Form
          ref={this.formRef}
          name="basic"
          className="basicForm"
          layout="vertical"
          onValuesChange={(changedFields, allFields) =>
            this.props.setAttributes(changedFields)
          }
        >
          <Form.Item {...genFormItemAtrribute('productId', '商品代碼')}>
            <Input
              placeholder="請輸入商品十一碼"
              onInput={this.handleInput}
              maxLength={11}
            />
          </Form.Item>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/stock/stock-all.js